import React, { useEffect, useRef } from 'react';
import makeIconName from '../../utils/makeIconName';
import makeBodyText from '../../utils/makeText';
import { ICONS } from '../../constants/icons';
import styles from './index.module.scss';
import { ARROW_DOWN, ARROW_UP, ENTER_KEYDOWN } from '../../constants/keydown';
const ListPanel = ({ selectedItem, itemsList, onElemClick, textSize, matchValue, isSearchStarted, suggestionOption, parentRef, isEmail = false }) => {
    const ref = useRef(null);
    const _renderPlaceholder = () => {
        if (isEmail) {
            return null;
        }
        return (React.createElement("div", { className: styles.placeholderWrap },
            React.createElement("span", { className: `${makeBodyText('L')} ${styles.text}` }, "Sorry, nothing was found")));
    };
    const renderSuggestion = () => {
        if (!suggestionOption) {
            return null;
        }
        const { id, label, isDisabled } = itemsList.find(({ id: idFind }) => idFind === suggestionOption);
        if (selectedItem === id || matchValue) {
            return null;
        }
        return (React.createElement("button", { id: id, key: 'suggestion', type: 'button', "data-label": label, onMouseDown: onElemClick, disabled: isDisabled, className: `${styles.listItem} ${styles.suggestion}` },
            React.createElement("span", { className: `${styles.text} ${makeBodyText(textSize || 'L')}` }, label)));
    };
    const showYellow = ({ matchedWords, isSelected }) => {
        if (!matchedWords) {
            return null;
        }
        if (isSelected) {
            return React.createElement("span", null, matchedWords);
        }
        return React.createElement("span", { className: styles.matchedWords }, matchedWords);
    };
    const showRest = ({ match, label, matchedWords }) => {
        const restWords = (match && label.replace(match[0], '')) || label;
        if (matchedWords === restWords) {
            return null;
        }
        if (selectedItem === restWords) {
            return React.createElement("span", null, restWords.replace(selectedItem, ''));
        }
        return restWords;
    };
    const _renderItems = () => {
        const isWholeListAppearAllowed = selectedItem && !isSearchStarted;
        return itemsList.map(({ id, label, isDisabled }) => {
            const regExp = new RegExp(`^${matchValue}`, 'i');
            const isSelected = selectedItem === id;
            const match = label.match(regExp);
            const matchedWords = match && match[0];
            const isElemNotMatched = matchValue && !match;
            if (!isWholeListAppearAllowed && isElemNotMatched) {
                return null;
            }
            return (React.createElement("button", { id: id, key: id, type: 'button', "data-label": label, "data-testid": label, tabIndex: 0, onMouseDown: onElemClick, disabled: isDisabled, className: styles.listItem },
                React.createElement("span", { className: `${styles.text} ${makeBodyText(textSize || 'L')}` },
                    showYellow({ matchedWords, isSelected }),
                    showRest({ match, label, matchedWords })),
                isSelected && React.createElement("i", { className: `${makeIconName(ICONS.x24.checked, 'x24')} ${styles.icon}` })));
        });
    };
    const itemsToRender = _renderItems();
    const isEmptyList = () => itemsToRender.every((elem) => elem === null);
    const handleTopOption = (e) => {
        if (e.keyCode === ARROW_UP && (!e.target.previousSibling || e.target.previousSibling.previousSibling)) {
            if (e.target.tagName !== 'INPUT') {
                return parentRef.current.querySelector('input').focus();
            }
        }
    };
    const navigationHandler = ({ e, isFocused, active, childrens }) => {
        const firstEl = childrens[0];
        if (e.keyCode === ARROW_DOWN && !isFocused) {
            e.preventDefault();
            return firstEl.focus();
        }
        if (e.keyCode === ENTER_KEYDOWN) {
            onElemClick(e);
        }
        if (e.keyCode === ARROW_DOWN && active.nextSibling) {
            if (active.nextSibling.disabled) {
                return active.nextSibling.nextSibling.focus();
            }
            return active.nextSibling.focus();
        }
        if (e.keyCode === ARROW_UP && active.previousSibling) {
            if (active.previousSibling.disabled) {
                return active.previousSibling.previousSibling.focus();
            }
            return active.previousSibling.focus();
        }
        handleTopOption(e);
    };
    const updateFocusedOption = (e) => {
        const childrens = ref && ref.current && ref.current.childNodes;
        const active = e.target;
        if (!childrens) {
            return false;
        }
        const isFocused = active.tagName === 'BUTTON';
        return navigationHandler({ e, isFocused, active, childrens });
    };
    useEffect(() => {
        parentRef.current.addEventListener('keydown', updateFocusedOption, true);
        return () => {
            if (parentRef.current) {
                parentRef.current.removeEventListener('keydown', updateFocusedOption);
            }
        };
    }, [parentRef]);
    return (React.createElement("div", { ref: ref, className: `${styles.listPanelWrap} ${isEmptyList() ? `${styles.withoutScroll} emptyList` : ''}` }, !isEmptyList() ? (React.createElement(React.Fragment, null,
        renderSuggestion(),
        itemsToRender)) : (_renderPlaceholder())));
};
export default ListPanel;
